"use client";
import { Globe, X } from "lucide-react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { Select, SelectContent } from "@/components/ui/select";
import { usePathname, useRouter } from "next/navigation";
import * as Dialog from "../../clients/Dialog";

import { useScopedI18n } from "@/messages/client";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { localeMiddleware } from "@/app/actions";

const locales = [
  {
    label: "English",
    icon: "/icons/global.svg",
    url: "/en",
  },
  {
    label: "简体中文",
    icon: "/icons/cn.svg",
    url: "/",
  },
];

export function SiteSelect() {
  const router = useRouter();

  const pathname = usePathname();

  const currentLocale = useCurrentLocale();

  return (
    <div className="flex items-center">
      <Select
        onValueChange={(url) => {
          const lang = url === "/" ? "cn" : "en";

          const urlhost = pathname.replace("/" + currentLocale, "");
          router.replace(
            `${url === "/" ? "" : url}${urlhost === "" ? "/" : urlhost}`
          );

          // 动态修改为根据data-lang来判断
          document.documentElement.setAttribute(
            "data-lang",
            lang === "cn" ? "zh" : "en"
          );
          document.documentElement.setAttribute(
            "lang",
            lang === "cn" ? "zh" : "en"
          );
          localeMiddleware(lang);
        }}>
        <SelectPrimitive.Trigger aria-label="Site">
          <div className="flex items-center space-x-2 text-[#383838]">
            <Globe size={18} />
            <span className="text-sm">
              {currentLocale === "cn" ? "简体中文" : "English"}
            </span>
          </div>
        </SelectPrimitive.Trigger>
        <SelectContent className="border border-[#E5E5E5] bg-white">
          {locales.map((locale, index) => {
            return (
              <SelectPrimitive.Item
                className={
                  "hover:bg-gray-100 relative flex w-full cursor-pointer items-center rounded-sm p-1 text-sm outline-none"
                }
                key={index}
                value={locale.url}>
                <div className="flex cursor-pointer items-center space-x-2 p-1 hover:text-[#cc2016]">
                  <img src={locale.icon} className="w-4" alt="" />
                  <span className="text-sm">{locale.label}</span>
                </div>
              </SelectPrimitive.Item>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}

export function MobileLanguageMenu() {
  const t = useScopedI18n("全局导航条");

  const currentLocale = useCurrentLocale();

  const router = useRouter();

  const pathname = usePathname();

  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <div
          className={cn("cursor-pointer text-[#2C2C2C]", {
            "text-primary": open,
          })}>
          <Globe size={18} />
        </div>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="fixed left-0 top-11 z-40 h-32 w-full border-b border-[#E5E5E5] bg-white shadow-[0px_2px_8px_0px_rgba(0,0,0,0.1)] outline-none !duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-top-1/4 data-[state=open]:slide-in-from-top-1/4">
          <div className="">
            <div className="px-3">
              <div className="border-b py-3">
                <Dialog.Close asChild>
                  <div className="flex items-center space-x-2">
                    <X size={18} className="text-gray-400" />
                    <span className="text-sm text-primary">{t("关闭")}</span>
                  </div>
                </Dialog.Close>
              </div>
            </div>
            <div className="mx-4">
              <div
                className="cursor-pointer py-3"
                onClick={() => {
                  const lang = currentLocale === "cn" ? "en" : "cn";
                  const urlhost = pathname.replace("/" + currentLocale, "");

                  const url = currentLocale === "cn" ? "/en" : "/";

                  router.replace(
                    `${url === "/" ? "" : url}${urlhost === "" ? "/" : urlhost}`
                  );

                  // 动态修改为根据data-lang来判断
                  document.documentElement.setAttribute(
                    "data-lang",
                    lang === "cn" ? "zh" : "en"
                  );
                  document.documentElement.setAttribute(
                    "lang",
                    lang === "cn" ? "zh" : "en"
                  );
                  localeMiddleware(lang);
                }}>
                {currentLocale === "cn" ? "English" : "简体中文"}
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
